import React from "react";
import InstaImages from "./../../../../../HomePage/InstaFeed/InstaImages";
import "./HairBotoxTreatmentXp.css";
const HairBotoxTreatmentXp = () => {
  return (
    <div className="hairBotoxTreatmentXp">
      <div className="hairBotoxTreatmentXpVid">
        <div className="hairBotoxTreatmentXpVid-Content">
          <InstaImages vid="https://www.youtube.com/embed/uGTyYbH2gN0" />
        </div>
        <div className="hairBotoxTreatmentXpVid-Content">
          <InstaImages vid="https://www.youtube.com/embed/UYZ3EGpRQoo" />
        </div>
      </div>
      <h5>Customer Experiences with Hair Botox</h5>
      <p>
        Many people who have undergone{" "}
        <a href="https://scentlifestyle.com/hair-botox-treatments-in-bangalore">
          Hair Botox treatments
        </a>{" "}
        have shared positive feedback. Clients often report softer, smoother
        hair that requires less styling effort. The long-lasting results are
        also a highlight, as individuals find that their hair remains manageable
        even in humid conditions. This feedback makes Hair Botox a preferred
        choice among those looking to revitalize their hair without harsh
        chemicals.
      </p>
    </div>
  );
};

export default HairBotoxTreatmentXp;
